// https://app.growthbook.io/features/pen-7570_v1
export const EXPERIMENT_FLAG = 'pen-7570_v1'
